import { LOGO_RATIO } from '@mews-distributor/common';
import { ImageResizeMode } from '@mews/enums';
import { propertyLogoFactory } from '@mews/gx-ui';

import { ServerImage } from '../../service';

const logoSizes = '(max-width: 500px) 25vw, (max-width: 800px) 20vw, (max-width: 1300px) 15vw, 10vw';
const widthSet = [240, 320, 480, 640];

export const Logo = propertyLogoFactory({
    ImageComponent: (props) =>
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        props.id ? (
            <ServerImage
                mode={ImageResizeMode.FitExact}
                ratio={LOGO_RATIO}
                // @ts-expect-error $TSFixMeError: Type '{ src: string; onLoad?: ((event: SyntheticEvent<HTMLElement, Event>) => void) | undefined; shouldShowLoader?: bool...
                widthSet={widthSet}
                sizes={logoSizes}
                {...props}
            />
        ) : null,
});
